const Credential = () =>
  import(
    /* webpackChunkName: "transport-bol-driver" */ '@/pages/transport/credential/index.vue'
  )

const CreateCredential = () =>
  import(
    /* webpackChunkName: "transport-credential" */ '@/pages/transport/credential/create.vue'
  )

const EditCredential = () =>
  import(
    /* webpackChunkName: "transport-credential" */ '@/pages/transport/credential/edit.vue'
  )

export default {
  path: 'credential',
  meta: {
    label: 'credential',
    auth: 'credential'
  },
  component: {
    name: 'Credential',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CredentialReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Credential
    },
    {
      name: 'CreateCredential',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCredential
    },
    {
      name: 'EditCredential',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCredential,
      props: true
    }
  ]
}
